import { render } from "./publicQuestionScreen.vue?vue&type=template&id=b8c9961c&scoped=true"
import script from "./publicQuestionScreen.vue?vue&type=script&lang=js"
export * from "./publicQuestionScreen.vue?vue&type=script&lang=js"

import "./publicQuestionScreen.vue?vue&type=style&index=0&id=b8c9961c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c9961c"]])

export default __exports__